export class ProductsEnvironment {
  public static getName = () => 'benzinga-products';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
